import { Flex, Typography } from "antd";

import { UserListEntity, USER_SCOPE_TEXTS } from "interfaces";
import { dateFormat } from "utils";
import { Status } from "ui";

import styles from "./profileHeader.module.css";
import { ChangePasswordButton } from "../ChangePassword";

export const ProfileHeader = ({ user }: { user: UserListEntity }) => {
  const { name, surname, secondName, status, createdAt } = user;

  return (
    <Flex justify="space-between" align="start">
      <Flex vertical align="start">
        <Typography.Title className={styles.username}>
          {surname} {name} {secondName}
        </Typography.Title>

        <Flex gap="middle" align="center">
          <Status color={USER_SCOPE_TEXTS.colors[status]} children={USER_SCOPE_TEXTS.texts[status]} />
          {/* <Typography.Text type="secondary">c {dateFormat(createdAt)}</Typography.Text> */}
        </Flex>
      </Flex>

      <Flex gap="large" align="center">
        <Typography.Text type="secondary">Дата регистрации: {dateFormat(createdAt, true)}</Typography.Text>
        <ChangePasswordButton />
      </Flex>
    </Flex>
  );
};
